import BarContainer from './components/BarContainer.jsx';
import ManageFlightsBtn from './components/ManageFlightsBtn.jsx';
import RowActionsAndExport from './components/RowActionsAndExport.jsx';
import SendOrderBtn from './components/SendOrderBtn.jsx';

const FlightActionBar = () => {
  return (
    <BarContainer>
      <div className="flex gap-2">
        <ManageFlightsBtn />
        <SendOrderBtn />
      </div>
      <div>
        <RowActionsAndExport />
      </div>
    </BarContainer>
  );
};

export default FlightActionBar;
